module.exports = __webpack_public_path__ + "static/img/2.5164cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/2.png
// module id = hQFZ
// module chunks = 1